import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastComponent} from './view/toast/toast.component';
import {ToastrModule} from 'ngx-toastr';

@NgModule({
  imports: [
    CommonModule,
    ToastrModule.forRoot({
      autoDismiss: false,
      closeButton: true,
      enableHtml: true,
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      tapToDismiss: true,
      newestOnTop: true
    }),
  ],
  declarations: [ToastComponent],
  exports: [ToastComponent, ToastrModule]
})
export class ToastrImplModule {
}
